import React from 'react';

/**
 * MicOffIcon - holito brand-tier icon (2px stroke, 24 grid, the notch where applicable).
 * Geometry from the brand guide (docs/DESIGN.md section 08 / Iconography).
 */
export const MicOffIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M15 6 V10 A3 3 0 0 1 9 10 V6 A3 3 0 0 1 15 6 Z" />
    <path d="M7 12 A5 5 0 0 0 17 12" />
    <path d="M12 17 V20" />
    <path d="M8 20 H16" />
    <path d="M5 4 L19 20" />
  </svg>
);
